import { type ClassValue, clsx } from "clsx";
import { extendTailwindMerge } from "tailwind-merge";

// Custom sizes and spacing from theme.css. Unregistered, a `text-*` it doesn't know reads as a colour,
// so `cn("text-card-subtitle", "text-subtle-foreground")` would drop one of the two.
const twMerge = extendTailwindMerge({
    extend: {
        theme: {
            text: ["card-title", "card-subtitle", "card-heading", "pill", "control"],
            spacing: ["card-header-y", "card-header-row", "pill-icon"],
        },
    },
});

export function cn(...inputs: ClassValue[]) {
    return twMerge(clsx(inputs));
}
